"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSetWinner = void 0;
var rules_1 = require("../rules");
var get_game_winner_1 = require("./get-game-winner");
/**
 * @internal
 * Determines the winner (if any) of a __played__ set (doesn't work with walkover).
 * @param set The set that was played
 * @param rules The rules to determine who has won
 * @returns
 * - `home` when the home player has won
 * - `away` when the away player has won
 * - `undefined` when no winner can be determined.
 */
function getSetWinner(set, rules) {
    rules_1.assertSetRules(rules);
    var reqWins = Math.ceil(rules.bestOf / 2);
    var homeWins = 0;
    var awayWins = 0;
    for (var gameIndex = 0; gameIndex < set.games.length; gameIndex++) {
        var game = set.games[gameIndex];
        var gameWinner = get_game_winner_1.getGameWinner(game, rules.gameRules);
        if (gameWinner == "home")
            homeWins++;
        if (gameWinner == "away")
            awayWins++;
        if (gameWinner == undefined)
            break;
        if (homeWins >= reqWins)
            return "home";
        if (awayWins >= reqWins)
            return "away";
    }
    return undefined;
}
exports.getSetWinner = getSetWinner;
